import { AutoComplete, Modal } from 'antd';
import { useContext, useEffect, useState } from 'react';
import AppContext from '../../App.context';
import { addBeneficiary } from '../../api/NetworkingBeneficiaries';
import { getCountryByName } from '../../api/NetworkingCountries';
import { updateInvoiceBeneficiary } from '../../api/NetworkingInvoice';
import { getStatesByCountryMin } from '../../api/NetworkingStates';
import { LookUpTableDetail } from '../../api/hooks/useLookUpTables';
import { formatValidInputClass, validInputClass } from '../../helpers/FormatHelper';
import { getResource } from '../../helpers/ResourcesHelper';
import Button from '../inputs/Button';
import Dropdown from '../inputs/Dropdown';
import Input from '../inputs/Input';
import ConfirmationModal from '../others/ConfirmationModal';
interface BeneProps {
  beneEmail: string;
  invoiceID: number;
  beneficiaryTypes: any;
  open: boolean;
  close: () => void;
  beneName: string;
  updateToken: string
}
const NewBeneficiary: React.FC<BeneProps> = (props) => {
  const { showModal, showLoadingModal, hideLoadingModal } = useContext(AppContext);
  const [beneficiaryID, setBeneficiaryID] = useState(0);
  const [beneficiaryType, setBeneficiaryType] = useState('Corporate');
  const [beneficiaryName, setBeneficiaryName] = useState(props.beneName);
  const [beneficiaryFirstName, setBeneficiaryFirstName] = useState(props.beneName);
  const [beneficiaryLastName, setBeneficiaryLastName] = useState('');
  const [beneficiaryEmail, setBeneficiaryEmail] = useState(props.beneEmail);
  const [addressLine1, setAddressLine1] = useState('');
  const [countryID, setCountryID] = useState('');
  const [countryIDName, setCountryIDName] = useState('');
  const [stateID, setStateID] = useState(0);
  const [stateName, setStateName] = useState('');
  const [states, setStates] = useState([]);
  const [countries, setCountries] = useState([]);
  const [showOpenAlert, setShowOpenAlert] = useState(false);



  const [validations, setValidations] = useState({
    beneficiaryType: true,
    beneficiaryFirstName: true,
    beneficiaryName: true,
    beneficiaryLastName: true,
    addressLine1: true,
    stateID: true,
    countryID: true,
    email: true
  });

  const validationsFields = () => {
    var type = validInputClass(beneficiaryType);
    var firstName = validInputClass(beneficiaryFirstName);
    var name = validInputClass(beneficiaryName);
    var lastName = validInputClass(beneficiaryLastName);
    var address = validInputClass(addressLine1);
    var country = validInputClass(countryID);
    var state = validInputClass(stateID.toString());
    var emailValid = validInputClass(beneficiaryEmail);

    setValidations({
      beneficiaryType: type,
      beneficiaryFirstName: firstName,
      beneficiaryName: name,
      beneficiaryLastName: lastName,
      addressLine1: address,
      countryID: country,
      stateID: state,
      email: emailValid
    });
    var nameValid = (beneficiaryType == 'Personal') ? firstName && lastName : name;
    var isValid = type && nameValid && address && country && state && emailValid;
    if (!isValid) { showModal(getResource('Js_MessageError_TitleError'), getResource('Js_MessageError_FormValidationNFieldNHighlighted')); }

    return isValid;
  }
  useEffect(() => {
    setBeneficiaryName(props.beneName);
    setBeneficiaryEmail(props.beneEmail);
  }, [props.beneEmail, props.beneName]);

  const updateStates = (countryID: string) => {
    getStatesByCountryMin(countryID).then(response => {

      if (response != null && response.httpStatusCode === 200 && response.states != null) {
        let states = response.states
        states = states.map((x: typeof states) => ({ label: x['State Name'], value: x['State ID'] }));
        let state = states.find((x: typeof states) => x.value == stateID);
        if (state == null) {
          setStateID(0);
          setStateName('');
        }
        setStates(states);
      }
    });
  }

  const beneficiaryTypeChangeHandler = (detail: LookUpTableDetail) => {
    if (detail != null) {
      setBeneficiaryType(detail.value);
      setValidations({ ...validations, beneficiaryType: true });
    }
  };

  const countryChangeHandler = (item: any, option: any) => {

    if (option != null && !option.label.includes('Select')) {
      setCountryID(option.label);
      setValidations({ ...validations, countryID: true });
      updateStates(item);
    }
  }

  const onSearch = (value: any) => {
    setCountryID(value);
    let newValue = value.split(' -');
    if (value === '') setStates([]);
    getCountryByName(newValue[0]).then(
      (json) => {
        if (json.countries != null) {
          const formattedCountries = json.countries.map((c: any) => ({ ...c, label: c.CountryIdName, value: c.CountryId }));
          setCountries(formattedCountries);
        }
      }
    )
  }

  const stateChangeHandler = (item: any, name: string) => {
    if (item != null) {
      setStateID(item.value);
      setValidations({ ...validations, stateID: true });
    }
  }

  const onChangeName = (e: any) => {
    setBeneficiaryName(e.target.value);
    setValidations({ ...validations, beneficiaryName: true });
  }

  const onChangeFirstName = (e: any) => {
    setBeneficiaryFirstName(e.target.value);
    setValidations({ ...validations, beneficiaryFirstName: true });
  }

  const onChangeLastName = (e: any) => {
    setBeneficiaryLastName(e.target.value);
    setValidations({ ...validations, beneficiaryLastName: true });
  }

  const onChangeEmail = (e: any) => {
    setBeneficiaryEmail(e.target.value);
  }

  const onChangeAddress1 = (e: any) => {
    setAddressLine1(e.target.value);
    setValidations({ ...validations, addressLine1: true });
  }

  const onClickExit = () => {
    clearData();
    if (props.close) {
      props.close();
    }
  }

  const onSaveClick = () => {

    if (validationsFields()) {
      saveAll();
    }
  }

  const saveAll = async () => {
    let UserID = localStorage.getItem('UserID');
    const userSession = JSON.parse(localStorage.getItem('UserSession')!)
    let customerID = userSession.CustomerID;
    let Status = 'Authorized';

    let name = beneficiaryName;
    if (beneficiaryType !== 'Corporate') {
      name = `${beneficiaryLastName}, ${beneficiaryFirstName}`;
      setBeneficiaryName(name);
    }

    var objFilter = {
      BeneficiaryId: 0,
      CustomerId: customerID,
      //StatusBeneficiary: this.state.objBeneInfo.status,
      StatusBeneficiary: Status,
      BeneficiaryType: beneficiaryType,
      BypassValidation: true,
      ContactEmail: beneficiaryEmail,
      ContactPhone: '',
      EmailIndicator: '',
      DetailsOfPayment: '',
      ExpiryByPassDate: '',
      IndustrySector: '',
      ReferencesOfPayment: '',
      PaymentFlow: 'Receives from',
      Salutation: '',
      Name: name,
      ContactName: name,
      FirstName: beneficiaryFirstName,
      LastName: beneficiaryLastName,
      ShortName: '',
      Email: beneficiaryEmail,
      Phone: '',
      PhoneExt: '',
      OfficeFax: '',
      MobilePhone: '',
      UpdateToken: '',
      UserId: UserID,
      CustomerRelationRisk: 0,
      PreferredMethodOfPayment: '',
      PreferredDeliveryMethod: '',

      Address: {
        AddressValue: addressLine1,
        StateID: stateID,
        CountryID: countryID,
        AddressType: 'Main Address'
      },
      BankAccounts: null
    }


    addBeneficiary(objFilter).then(
      (json) => {
        if (json.httpStatusCode !== 200 && json.httpStatusCode !== 409) {
          let message = 'An error occurred while trying to save the beneficiary. Please try again and complete the required fields(*).';
          if (json.Message && json.Message !== '') {
            message = json.Message;
          }
          showModal(getResource('Error'), message);
        } else if (json.httpStatusCode !== undefined && json.httpStatusCode === 409) {
          showModal(getResource('Error'), json.httpErrorMessage);
        } else {
          setBeneficiaryID(json.beneficiaryId);
          setShowOpenAlert(true);
        }
      }
    );

  }

  const yesUpdateInfo = () => {
    //setState({ showConfirmation: false });
    showLoadingModal();
    var userID = localStorage.getItem('UserID');
    let invoice = {
      InvoiceIssuedId: props.invoiceID,
      ExternalCustomerID: beneficiaryID,
      ExternalCustomerName: beneficiaryName,
      ExternalCustomerEmail: beneficiaryEmail,
      CreatedBy: userID,
      BeneficiaryID: beneficiaryID,
      UpdateToken: props.updateToken
    }

    updateInvoiceBeneficiary(invoice).then(
      (response) => {
        if (typeof response !== undefined && response.httpStatusCode === 200) {
          hideLoadingModal();
          showModal(getResource('Js_MessageError_TitleSuccess'), getResource('Js_Message_SaveSuccessfully'));
          clearData();
          setShowOpenAlert(false);
          if (props.close) {
            props.close();
          }
        }
        else {
          hideLoadingModal();
          showModal(getResource('Js_MessageError_TitleError'), getResource('SomethingWentWrongTryAgain'));
        }
      });
  }

  const cancelUpdateInfo = () => {
    clearData();
    setShowOpenAlert(false);
    if (props.close) {
      props.close();
    }
  }

  const clearData = () => {
    setBeneficiaryID(0);
    setBeneficiaryEmail('');
    setAddressLine1('');
    setBeneficiaryFirstName('');
    setBeneficiaryLastName('');
    setBeneficiaryName('');
    setBeneficiaryType('Corporate');
    setCountryID('');
    setStateID(0);
  }


  return (
    <div>
      <Modal
        title={<h3 className="component-title">{'New Beneficiary'}</h3>}
        centered
        open={props.open}
        footer={null}
        //onCancel={props.changeState()}
        maskClosable={false}
        className='modal-message'
        zIndex={1000}
        closable={false}
      >
        <div className="row">
          <div className="col-md-6 col-xs-12">
            <div className="row">
              <span className="input-label">{getResource('Label.BeneficiaryType') + '(*)'}</span>
            </div>
            <div className="row">
              <Dropdown
                name="beneficiaryType"
                title={getResource('SelectType') + '...'}
                list={props.beneficiaryTypes.filter((x: { value: string; }) => !['Select a Type...'].includes(x.value))}
                select={{ value: beneficiaryType }}
                errorMessage={getResource('DataMsgRequired')}
                className={formatValidInputClass(validations.beneficiaryType)}
                onChange={beneficiaryTypeChangeHandler}
              />
            </div>
          </div>
        </div>
        {beneficiaryType !== 'Corporate' && (
          <div className="row">
            <div className="col-md-6 col-xs-12">
              <div className="row">
                <span className="input-label">{getResource('Label.FirstName') + '(*)'}</span>
              </div>
              <div className="row">
                <Input type="text" onChange={onChangeFirstName} value={beneficiaryFirstName} errorMessage={getResource('DataMsgRequired')}
                  className={formatValidInputClass(validations.beneficiaryFirstName)}
                ></Input>
              </div>
            </div>
            <div className="col-md-6 col-xs-12">
              <div className="row">
                <span className="input-label">{getResource('Label.LastName') + '(*)'}</span>
              </div>
              <div className="row">
                <Input type="text" onChange={onChangeLastName} value={beneficiaryLastName} errorMessage={getResource('DataMsgRequired')}
                  className={formatValidInputClass(validations.beneficiaryLastName)}></Input>
              </div>
            </div>
          </div>
        )}
        {beneficiaryType === 'Corporate' && (
          <div className="row">
            <div className="col-md-6 col-xs-12">
              <div className="row">
                <span className="input-label">{getResource('Js_TH_Name') + '(*)'}</span>
              </div>
              <div className="row">
                <Input type="text" onChange={onChangeName} value={beneficiaryName} errorMessage={getResource('DataMsgRequired')}
                  className={formatValidInputClass(validations.beneficiaryName)}></Input>
              </div>
            </div>
          </div>
        )}
        <div className="row">
          <div className="col-md-6 col-xs-12">
            <div className="row">
              <span className="input-label">{getResource('Label.Email') + '(*)'}</span>
            </div>
            <div className="row">
              <Input type="text" className={formatValidInputClass(validations.email)} onChange={onChangeEmail} value={beneficiaryEmail}></Input>
            </div>
          </div>
          <div className="col-md-6 col-xs-12">
            <div className="row">
              <span className="input-label">{getResource('Label.Address1') + '(*)'}</span>
            </div>
            <div className="row">
              <Input type="text" onChange={onChangeAddress1} value={addressLine1} errorMessage={getResource('DataMsgRequired')}
                className={formatValidInputClass(validations.addressLine1)}></Input>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 col-xs-12">
            <div className="row">
              <span className="input-label">{getResource('Label.Country') + '(*)'}</span>
            </div>
            <div className="row">
              <AutoComplete
                allowClear
                options={countries}
                className={formatValidInputClass(validations.countryID)}
                placeholder={getResource('SelectCountry')}
                notFoundContent={getResource('PlaceHolder.NoResults')}
                value={countryID}
                onSelect={countryChangeHandler}
                onSearch={onSearch}
              />
            </div>
          </div>
          <div className="col-md-6 col-xs-12">
            <div className="row">
              <span className="input-label">{getResource('Label.ProvinceState') + '(*)'}</span>
            </div>
            <div className="row">
              <Dropdown name="state" title={getResource('SelectState')} list={states}
                select={{ value: stateID }} onChange={stateChangeHandler}
                errorMessage={getResource('DataMsgRequired')}
                className={formatValidInputClass(validations.stateID)}
              />
            </div>
          </div>
        </div>
        <div className="row-actions">
          <Button id="exit-button" type="secondary" onClick={onClickExit}>
            {getResource('Btn_Exit')}
          </Button>
          <Button id="exit-button" type="primary" onClick={onSaveClick}>
            {getResource('Button.Save')}
          </Button>
        </div>
      </Modal>
      <ConfirmationModal visible={showOpenAlert} cancel={cancelUpdateInfo} confirm={yesUpdateInfo} title={getResource('ConfirmUpdateInvoice')} />

    </div>
  );
}
export default NewBeneficiary;